module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point1_7-965b32d23a562ac2b57c14d77c4195ea.jpg";